import { FC } from "react";
import styles from "./VoucherInfo.module.scss";
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";

const VoucherInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container)}>
      <p>
        <Trans i18nKey="mainPage.vouchers.doYouHave">
          <b></b>
        </Trans>
      </p>
      <p>{t("mainPage.vouchers.scanForDiscount")}</p>
    </div>
  );
};

export default VoucherInfo;
